import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import logo from '../assets/img/myGuardianLinklogo.png';
import { resetPasswordApi } from '../api/auth.api';
import { apiHandler } from '../utils/apiHandler';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  async function handleSubmit() {
    setError('');
    if (!token) {
      setError('Invalid or missing reset token.');
      return;
    }
    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    const result = await apiHandler(() =>
      resetPasswordApi({ token, password })
    );
    setLoading(false);
    if (result.success) {
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } else {
      setError(result.message || 'Reset failed');
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--guardian-navy)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: '100%', maxWidth: 420 }}>
        <img src={logo} alt="MyGuardianLink" style={{ height: 40, marginBottom: 20 }} />
        <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Reset password</h1>
        {success ? (
          <p style={{ color: '#15803D' }}>Password updated. Redirecting to login…</p>
        ) : (
          <>
            <input
              type="password"
              className="filter-input"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: '100%', marginBottom: 12 }}
            />
            <input
              type="password"
              className="filter-input"
              placeholder="Confirm password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              style={{ width: '100%', marginBottom: 12 }}
            />
            {error && <p style={{ color: '#B91C1C', fontSize: 13 }}>{error}</p>}
            <button type="button" className="action-btn btn-orange" style={{ width: '100%', marginTop: 12 }} onClick={handleSubmit} disabled={loading}>
              {loading ? 'Saving…' : 'Reset password'}
            </button>
          </>
        )}
        <p style={{ marginTop: 16, fontSize: 13 }}>
          <Link to="/login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
